export const PaymentStatus = {
    PAID: 'Paid',
    UNPAID: 'Unpaid',
    FAILED: 'Failed',
    PENDING: 'Pending'
}